import type { Currency, Security } from '@talos/kyoko';
import type { CrossAssetRiskGroup } from '../../containers/Admin/TradingLimits/SubAccountTradingLimits/crossAssetRiskGroupsApi';

/** Writes use `""` for single-asset (no group). Older responses still send `"0"`. */
export const SINGLE_ASSET_CROSS_ASSET_RISK_GROUP = '' as const;
const LEGACY_SINGLE_ASSET_CROSS_ASSET_RISK_GROUP = '0' as const;

export function isActiveCrossAssetRiskGroup(group: string | undefined | null): group is string {
  return (
    group != null &&
    group !== SINGLE_ASSET_CROSS_ASSET_RISK_GROUP &&
    group !== LEGACY_SINGLE_ASSET_CROSS_ASSET_RISK_GROUP
  );
}

export function normalizeHedgeCrossAssetRiskGroup(group: string | undefined | null): string {
  return isActiveCrossAssetRiskGroup(group) ? group : SINGLE_ASSET_CROSS_ASSET_RISK_GROUP;
}

export function getCrossAssetRiskGroupsForAsset(
  groups: CrossAssetRiskGroup[],
  assetSymbol: string | undefined
): CrossAssetRiskGroup[] {
  if (!assetSymbol) {
    return [];
  }
  return groups.filter(group => group.ExposureCurrency === assetSymbol);
}

/**
 * Group rules require a currency Asset; a security Asset must stay on single-asset (empty) scope.
 * Monitored asset options give currencies precedence over identically named securities, so a symbol
 * present in both maps is the currency the user picked.
 */
export function isMonitoredAssetSecurity(
  assetSymbol: string | undefined,
  securitiesBySymbol: Map<string, Security>,
  currenciesBySymbol: Map<string, Currency>
): boolean {
  return assetSymbol != null && !currenciesBySymbol.has(assetSymbol) && securitiesBySymbol.has(assetSymbol);
}
